<template>
  <div style=" display:flex;height: 100%;"   v-loading="loading" >
    <div v-if="leftNav.length" class="tab-next">
      <div v-for="item in leftNav" :key="item.id" @click="handleChangeFixed(item.id)" class="tabTag" :class="{activeTabTag:fixedId == item.id}"> {{item.label}}</div>
    </div>
    <div style="flex:1;padding:0 15px;display: flex;flex-direction: column;width: 1px;">
      <div class="fileTitle">基准文件</div>
      <div
          style="display: flex;flex-direction: column;flex:1;height: 1px;border:1px solid #DCDFE6;margin-top: 16px;border-radius: 5px;">
        <div
            style="background: #E5E6EB;height: 40px;line-height: 40px;padding-left: 20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-weight: bold;color: #000;">
          {{ showData.name }}/{{ showData.mulu }}
        </div>
        <div v-if="baseLoad" id="baseHtmlContainer"
             style="flex:1;height: 1px;overflow: auto;padding: 0 8px;position: relative;" v-html="baseHtml">
        </div>
      </div>
    </div>
    <div style="flex: 1;padding:0 15px;display: flex;flex-direction: column;width: 1px;">
      <div class="fileTitle">目标文件</div>
      <div
          style="display: flex;flex-direction: column;flex:1;height: 1px;border:1px solid #DCDFE6;margin-top: 16px;border-radius: 5px;">
        <div
            style="background: #E5E6EB;height: 40px;line-height: 40px;padding-left: 20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-weight: bold;color: #000;">
          {{ showData.cont_name }}/{{ showData.cont_mulu }}
        </div>
        <div v-if="contLoad"
             id="contHtmlContainer"
             style="display: flex;flex-direction: column;flex:1;height: 1px;overflow: auto;padding: 0 8px;position: relative;"
             v-html="contHtml">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getFile} from "@/api/word";
import {mapState} from "vuex";

export default {
  name: "textCmp",
  props: {
    contId: {
      type: String,
      required: true
    },
    baseId: {
      type: String,
      required: true
    },
    showData: {
      type: Object,
      required: true
    },
    abnormalResult: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      leftNav: [],
      fixedId: "",
      tabPosition: 'left',
      baseHtml: "",
      contHtml: "",
      baseLoad: false,
      contLoad: false,
      currentCont: null,
      currentContIndex: 0,
      currentContLength: 0,
      currentBase: null,
      currentBaseIndex: 0,
      currentBaseLength: 0,
      hasSimPara: false,
      currentParaIdx: '',
      currentPara: [],
      loading:false
    }
  },
  mounted() {
    this.init();

  },
  methods:{
    init(){
      this.loading = true;
      this.filterNav();
      this.initHtml();
    },
    initHtml(){
      this.loadBase();
      this.loadCont();
    },
    async loadBase(){
      this.baseHtml =""
      this.baseLoad = false;
      let res = await getFile({
        project: this.projectId,
        sign_name: this.sign_name,
        fileId: this.baseId
      });
      this.baseHtml = res.data;

      this.baseLoad = true;

      this.$nextTick(()=>{
        this.$Jquery(`.simUid_${this.contId}`).css({
          'color': "red"
        }).children().css({'color': "red"})

        this.$Jquery(`.simUid_${this.contId}`).off("click").on("click",(event)=>{
          event.stopPropagation();
          if (!this.baseLoad || !this.contLoad) {
            this.$message({
              type: "warning",
              message: "请等待文件加载完成，再进行相关操作！"
            })
            return
          }
          this.$Jquery(`.simUid_${this.baseId}`).removeClass('activeContainer');
          this.$Jquery(`.simUid_${this.contId}`).removeClass('activeContainer');
          let target = this.getSimParent(event.target) ? this.getSimParent(event.target) : false;
          if (!target) {
            return;
          }
          let clsArr = target.classList;
          let targetCls = "";
          let next = "";
          clsArr.forEach((item) => {
            if (item.startsWith('TYZL_')) {
              targetCls = item
            }
            if (item.startsWith('class3_ZLTY')) {
              next = item
            }
          })

          let el = this.$Jquery('#contHtmlContainer').find(`.${targetCls}`);
          let preNext = el.attr('class').split(' ');
          let pre = '';
          preNext.forEach(item => {
            if (item.startsWith('class3_ZLTY')) {
              pre = item
            }
          })
          this.fixedId = `${next}-${pre}`;

          this.handleChangeFixed(this.fixedId);

        })
        if(this.baseLoad && this.contLoad){
          this.loading = false;
        }

      })

    },
    async loadCont(){
      this.contHtml = "";
      this.contLoad = false;
      let res = await getFile({
        project: this.projectId,
        sign_name: this.sign_name,
        fileId: this.contId
      });
      this.contHtml = res.data;
      this.contLoad = true;
      this.$nextTick(() => {
        this.$Jquery(`.simUid_${this.baseId}`).css({
          'color': "red"
        }).children().css({'color': "red"})
        this.$Jquery(`.simUid_${this.baseId}`).off('click').on('click', (event) => {
          event.stopPropagation();
          if (!this.contLoad || !this.baseLoad) {
            this.$message({
              type: "warning",
              message: "请等待文件加载完成，再进行相关操作！"
            })
            return
          }
          this.$Jquery(`.simUid_${this.baseId}`).removeClass('activeContainer');
          this.$Jquery(`.simUid_${this.contId}`).removeClass('activeContainer');
          let target = this.getSimParent(event.target) ? this.getSimParent(event.target) : false;
          if (!target) {
            return;
          }
          let clsArr = target.classList;
          let targetCls = "";
          let next = "";
          clsArr.forEach((item) => {
            if (item.startsWith('TYZL_')) {
              targetCls = item
            }
            if (item.startsWith('class3_ZLTY')) {
              next = item
            }
          })
          let el = this.$Jquery('#baseHtmlContainer').find(`.${targetCls}`);
          let preNext = el.attr('class').split(' ');
          let pre = '';
          preNext.forEach(item => {
            if (item.startsWith('class3_ZLTY')) {
              pre = item
            }
          })
          this.fixedId = `${pre}-${next}`;
          this.handleChangeFixed(this.fixedId);
        })
      })
      if(this.baseLoad && this.contLoad){
        this.loading = false;
      }
    },
    /**
     * 递归查找父级
     */
    getSimParent(element) {
      let current = element;
      while (!this.$Jquery(current).hasClass("TAIYUAN")) {
        current = current.parentElement;
      }
      if (this.$Jquery(current).hasClass("TAIYUAN")) {
        return current
      } else {
        return false
      }
    },
    /**
     * 递归获取高度
     */
    getElementTop(element) {
      let actualTop = element.offsetTop ? element.offsetTop : 0
      let current = element.offsetParent
      while (current && current.id != 'contHtmlContainer' && current.id != 'baseHtmlContainer') {
        actualTop += current.offsetTop
        current = current.offsetParent
      }
      return actualTop
    },

    // 获取左边的导航栏
    filterNav() {
      this.leftNav = [];
      const idx = `${this.baseId}-${this.contId}`;
      let leftId = this.abnormalResult[idx];
      if (leftId?.length) {
        leftId.forEach((val, key) => {
          this.leftNav.push({
            id: val,
            label: `相似项${key + 1}`
          })
        })
      }
      this.fixedId = this.leftNav[0]?.id;
    },
    handleChangeFixed(item) {
      this.loading = true;
      this.fixedId = item;
      let classArray = this.fixedId.split('-');
      this.$Jquery(`.simUid_${this.baseId}`).removeClass('activeContainer');
      this.$Jquery(`.simUid_${this.contId}`).removeClass('activeContainer');
      let p0 = classArray[0];
      let dom0 = this.$Jquery(`.${p0}.simUid_${this.contId}`);
      dom0.addClass("activeContainer");
      let el0 = this.$Jquery('#baseHtmlContainer').find(`.${p0}`);
      let top0 = this.getElementTop(el0[0]);
      this.$Jquery('#baseHtmlContainer')[0].scrollTop = top0;
      let p1 = classArray[1];
      let dom1 = this.$Jquery(`.${p1}.simUid_${this.baseId}`);
      dom1.addClass("activeContainer");
      let el1 = this.$Jquery('#contHtmlContainer').find(`.${p1}`);
      let top1 = this.getElementTop(el1[0]);
      this.$Jquery('#contHtmlContainer')[0].scrollTop = top1;
      this.$nextTick(()=>{
        this.loading = false;
        this.$Jquery('.activeTabTag')[0]?.scrollIntoView({behavior:"smooth",block:"center"});
      })
    }
  },
  computed:{
    ...mapState('word',['projectId','sign_name'])
  },
  watch:{
    showData:{
      handler(val){
        this.init();
      }
    }
  }
}
</script>

<style scoped lang="scss">

.tab-next {
  max-width: 150px;
  flex: 1;
  height: 100%;
  overflow-y: auto;
  .tabTag{
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .activeTabTag{
    color: #409EFF;
    position: relative;
    &::after{
      display: block;
      content: "";
      width: 2px;
      background: #409EFF;
      position: absolute;
      height: 20px;
      top:5px;
      right: 10px;
    }
  }
}

</style>

<style lang="scss">
.activeContainer {
  background: #d9001b !important;
  color: #fff !important;

  span {
    color: #fff !important;

    background: #d9001b !important;
  }

  font {
    color: #fff !important;

    background: #d9001b !important;
  }

  p {
    color: #fff !important;

    background: #d9001b !important;
  }

}

.el-tabs--left .el-tabs__header.is-left {
  width: 95% !important;
}
</style>
